import React, { Component } from 'react'
import $ from 'jquery'
import Pagination from './Pagination.jsx';
import { apiClient } from "../helpers/common";
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

class Products extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            totalRecords: 0,
            totalItems: [],
            pageOfItems: [],
            showPagination: false,
            pageSize: 20,
        };
    }
    componentDidMount() {

        if (sessionStorage.getItem('adminDetails') !== undefined && sessionStorage.getItem('adminDetails') !== null) {
            this.getProductsList();
        } else {
            window.location.replace("/admin-login");
        }
    }
    componentDidUpdate() {

    }
    onChangePage = (items) => {
        this.setState({ pageOfItems: items });
    }
    getProductsList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('products-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            let pagination = result.data.length > 10 ? true : false
            this.setState({ totalItems: result.data, totalRecords: result.data.length, showPagination: pagination })
        }
    }

    changeStatus = async (e, id) => {
        e.preventDefault();

        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid: id,
            status:e.target.value
        }

        const result = await apiClient('active-deactive-product', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            this.getProductsList()
        }
    }

    productsListing = (data) => {
        if (data && data.length) {
            return (

                data.map((val, i) => {
                    return (
                        <tr key={i + 1} >
                          
                            <td>{val.uuid}</td>
                            <td>{val.created_at}</td>
                            <td>{val.name}</td>
                            <td>{val.category}</td>
                            <td>{val.store}</td>
                            <td>{val.seller}</td>
                            <td>{val.size}</td>
                            <td>{val.weight}</td>
                            <td>{val.price}</td>
                            {/* <td style={{ width: '5%' }}>{val.rating}</td>
                            <td style={{ width: '10%' }}>{val.description}</td> */}
                            <td>

                                <select
                                    className="form-control form-row-height"
                                    value={val.status}
                                    onChange={(e) => this.changeStatus(e, val.uuid)}
                                >
                                    <option value='A'>Active</option>
                                    <option value='D'>Inactive</option>
                                </select>
                            </td>
                            <td>
                                <a href="javascript:void(0)" className="ml-3" onClick={() => this.props.handleEditRequest(val.uuid)}><i class="fa fa-pencil"></i></a> &nbsp;&nbsp;
                                <a href="javascript:void(0)" onClick={(e) => this.handleDeleteAction(val.uuid)}><i class="fa fa-trash-o"></i></a>
                            </td>
                        </tr>
                    )
                })
            )
        }
    }

    handleInputValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    handleKeyUp = event => {
        var age = event.target.value;
        var result = age.replace(/[^\d\+]/g, '');
        event.target.value = result;

    }
    setGender = (e) => {
        this.setState({
            gender: e.currentTarget.value
        });
    }
    handleDeleteAction = (id) => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid: id,
        }
        swal({
            title: "Are you sure you want to delete this product?",
            closeOnClickOutside: false,
            buttons: true,
            dangerMode: true,
        }).then(async (isOk) => {
            if (isOk) {
                const result = await apiClient('delete-product', {
                    method: 'POST',
                    body: postData
                });

                if (result.status === 200) {
                    this.getProductsList();
                }
            } else {
                console.log('you clicked on false');
            }
        });
    }

    filterData = (e, key) => {

        let updatedList = this.state.totalItems;
        updatedList = this.state.totalItems.filter((val) => {
            if (e.target.value !== '') {
                if (val[key] !== null) {
                    if (key === 'rating') {
                        return val[key].toString().search(e.target.value) !== -1;
                    } else {
                        return val[key].toLowerCase().search(e.target.value.toLowerCase()) !== -1;
                    }

                }
            } else {
                return val
            }
        });

        this.setState({
            pageOfItems: updatedList.slice(0, 10),
            showPagination: updatedList.length > 10 ? true : false
        });
    }

    render() {
        const { pageSize } = this.state
        return (<>
            <div className="page_content">
                <section className="upper_section">
                    <div className="page_heading row">
                        <h3><span className="title">Products</span></h3>
                        <div className="page_actions">
                            <a href="javascript:void(0)" className="ml-3"><button type="submit" class="btn btn-default" onClick={() => this.props.handlePages("addProduct")}>Add Product</button></a>
                        </div>
                    </div>
                </section>
                <section className="lower_section">
                    <div className="row">
                        <div className="col-md-12 table-responsive  mt-3">
                            <div className="container-fluid bg-white p-0 mb-15 pb-0">
                                <table className="table table-striped table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            
                                            <th>Product ID</th>
                                            <th>Created On</th>
                                            <th>Name</th>
                                            <th>Category</th>
                                            <th>Store</th>
                                            <th>Seller</th>
                                            <th>Size</th>
                                            <th>Weight</th>
                                            <th>Price</th>
                                            {/* <th style={{ width: '5%' }}>Rating</th>
                                            <th style={{ width: '10%' }}>Description</th> */}
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {/* <td style={{ width: '10%' }}></td> */}
                                            <td></td>
                                            <td></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'name')} className="form-control" /></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'category')} className="form-control" /></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'store')} className="form-control" /></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'seller')} className="form-control" /></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'size')} className="form-control" /></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'weight')} className="form-control" /></td>
                                            <td ><input type="text" onChange={(e)=>this.filterData(e,'price')} className="form-control" /></td>
                                            {/* <td style={{ width: '5%' }}><input type="text" onChange={(e)=>this.filterData(e,'rating')} className="form-control" /></td> */}
                                            {/* <td style={{ width: '10%' }}></td> */}
                                            <td></td>
                                            <td></td> 
                                        </tr>
                                        {this.productsListing(this.state.pageOfItems)}
                                    </tbody>
                                </table>
                               

                            </div>
                        </div>
                         <div className="col-md-12 pt-3 pagingWrap pb-3">
                            <div className="row">
                                {this.state.totalRecords > 0 ? <Pagination items={this.state.totalItems} onChangePage={this.onChangePage} /> : ''}
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </>)
    }
}
export default Products